import { render, staticRenderFns } from "./AutomationAndQueryMaker.vue?vue&type=template&id=8c8c5ac0&scoped=true&"
import script from "./AutomationAndQueryMaker.vue?vue&type=script&lang=js&"
export * from "./AutomationAndQueryMaker.vue?vue&type=script&lang=js&"
import style0 from "./AutomationAndQueryMaker.vue?vue&type=style&index=0&id=8c8c5ac0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8c5ac0",
  null
  
)

export default component.exports